module.exports = __webpack_public_path__ + "static/media/service-window-order-date-1.aa058a73.png";